import { render, staticRenderFns } from "./OOGEntryPop.vue?vue&type=template&id=2e97f8a8"
import script from "./OOGEntryPop.vue?vue&type=script&lang=js"
export * from "./OOGEntryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e97f8a8')) {
      api.createRecord('2e97f8a8', component.options)
    } else {
      api.reload('2e97f8a8', component.options)
    }
    module.hot.accept("./OOGEntryPop.vue?vue&type=template&id=2e97f8a8", function () {
      api.rerender('2e97f8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/OOGEntryPop.vue"
export default component.exports